import {FilterLineupsByKeyPlayerStackCombinationsInterface} from './filter-lineups-by-key-player-stack-combinations-interface';

export function getFilteredLineupsByKeyPlayerStackCombinations(
    lineups,
    filterLineupsByKeyPlayerStackCombinations: FilterLineupsByKeyPlayerStackCombinationsInterface,
) {
    if (!filterLineupsByKeyPlayerStackCombinations.hasCheckedCombinations()) {
        return Object.values(lineups.all());
    }

    const lineupIds = filterLineupsByKeyPlayerStackCombinations.getLineupIds();

    return lineupIds.map((lineupId) => lineups.getLineup(lineupId)).filter((lineup) => lineup !== null);
}
